import { WagoApiClient } from '@shared/service/wago-api.client';
import { ModelConversionService } from '@shared/convert/model-conversion.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProjectOrderDTO } from '@article/model/vo/project-order.dto';
import { EShopWatchListsResultVO } from '@article/model/vo/eshop-watch-lists-result.vo';
import { IEKBuildingBlockVO } from '../model/vo/building-block.vo';
import { map } from 'rxjs/operators';

export type EShopAddedToWatchlistResponse = {
  watchListName: string,
  watchListGuid: string,
  storeFrontUrl: string,
}

@Injectable({ providedIn: 'root' })
export class EShopDataService {

  private readonly loadProjectByIdUrl: string = 'project/';

  constructor(private wagoApiClient: WagoApiClient, private modelConversionService: ModelConversionService) {}

  public addProjectToWatchlist(projectOrderDTO: ProjectOrderDTO): Observable<EShopAddedToWatchlistResponse> {
    return this.wagoApiClient.post<EShopAddedToWatchlistResponse>(
      this.loadProjectByIdUrl + 'addtowatchlist',
      projectOrderDTO,
      null,
      {
        isErrorHandlingRequired: false,
      }
    );
  }

  public getWatchLists(): Observable<EShopWatchListsResultVO> {
    return this.wagoApiClient.get<EShopWatchListsResultVO>(
      this.loadProjectByIdUrl + 'watchLists',
      null,
      {
        isErrorHandlingRequired: false,
      }
    );
  }

  public loadBuildingBlocksByEShopStorageId(storageId: string): Observable<IEKBuildingBlockVO[]> {
    return this.wagoApiClient
      .get(`eshop/assistant/building-blocks?storageId=${storageId}`, null, { isErrorHandlingRequired: false })
      .pipe(map((response) => this.modelConversionService.convertIEKBuildingBlockVOs(response)));
  }
}
